import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "m6,7.667l-6,-6l1.4,-1.4l4.6,4.6l4.6,-4.6l1.4,1.4l-6,6z"
	})
});
export default SvgChevronDown;
